import { useState, useEffect } from 'react';
import { SendMessage } from './App.js';
import icobackblue from './img/ico-backblue.svg';
import playpause from './img/playpause.svg';
import iconextsong from './img/ico-nextsong.svg';
import icoreplay from './img/ico-replay.svg';
import icoclosewhite from './img/ico-closeWhite.svg';
import icopause from './img/ico-pause.svg';
import icodelblue from './img/ico-delBlue.svg';
import contestCn from './img/contest-cn.jpg';
import contestEn from './img/contest-en.jpg';
import strings from './strings.js'
import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = "https://www.starboxkod.com/api";

const SelectingContestCard = ({ stateVer, onClick, lang}  ) => {

    


    const song = {
        "song_num": 110108,
        "song_name": "给我多一点",
        "singer": "SHE",
        "language": "国语",
        "server_id": "C",
        "rel_path": "05\\110108"
    }
    

    useEffect(() => {
      
    }, []);
  
    return (

    <div className="LMAOselecting">
        <div className="mui-overlay"
        onClick={(e) => {e.preventDefault(); /* onClick()83 19 5vw 5vw */}}
        ></div>
        <div className="actions-sheet2" 
        style={{paddingBottom: "5px", paddingTop: "5px", paddingLeft: "5px", paddingRight:"5px", left:"1vw", right:"1vw"}}
        onClick={(e) => {e.preventDefault(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation();}}>
            <div className="controlCardClose">
                <a className="controlCardCloseIcon" onClick={(e) => {e.preventDefault(); onClick() }}>
                <img 
                    src={icoclosewhite}
                    alt="close"
                />
                </a>
            </div>

            <img
                style={{ 
                    width: "100%", 
                    maxHeight: "80vh", 
                    objectFit: "contain" 
                }}
                src={lang ? contestCn : contestEn}
                alt="record"
            />

            
        </div>
    </div>


    );
}

export default SelectingContestCard;